module.exports = window["MaterialUI"].Typography;